import { SiteLayout } from "./home/SiteLayout";
import { PageHero } from "./home/components/PageHero";
import { RichText, useSiteTranslation } from "./home/i18n";
import { ContactSection } from "./help/ContactSection";

export default function ContactUsComponent() {
  const { t } = useSiteTranslation();

  return (
    <SiteLayout title={t("contactPage.title")}>
      <PageHero
        eyebrow={t("contactPage.eyebrow")}
        title={<RichText k="contactPage.heading" />}
        lead={t("contactPage.lead")}
      />
      <ContactSection />
    </SiteLayout>
  );
}
